'use-client'
import { LicenseInfo } from '@mui/x-license';

// const licenseKey = import.meta.env.PUBLIC_MUI_LICENSE;
const licenseKey = "9725ccc1d955338b9a509e0053bd9ba2Tz0xMDY4NjIsRT0xNzY5NzMxMTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"

LicenseInfo.setLicenseKey(licenseKey)

export default function MuiXLicense() {
    return null;
}